import { render, staticRenderFns } from "./BuyerCreateCampaign.vue?vue&type=template&id=dc0a4e34&scoped=true"
import script from "./BuyerCreateCampaign.vue?vue&type=script&lang=js"
export * from "./BuyerCreateCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0a4e34",
  null
  
)

export default component.exports